import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../models/dynamic-form-field';

@Component({
  selector: 'app-dynamic-text-area',
  templateUrl: './dynamic-text-area.component.html',
  styleUrls: ['./dynamic-text-area.component.scss']
})
export class DynamicTextAreaComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;

  constructor() {}

  ngOnInit() {}

}
